import React, { useCallback, useEffect, useRef, useState } from "react";
import SliderPressable from "../sliderPressable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EARLY_CHECKIN, PRE_CHECKIN } from "../../../config/Constant";
import { toBool } from "../../../utils/Helper";
import { formatTime, formatTimeFormat } from "../../../js/formatTime";
import CustomPressable from "../customPressable";
import { Text } from "react-native";
import { useCssStyle } from "../../../customHook/getCssStyle";


export const PreArrivalStateSlider = ({ handleOnSuccess }) => {

    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const { preCheckInWidgetState } = useSelector(state => state.checkInSlice);
    const { preCheckInCompleted, preCheckInData } = useSelector(state => state.checkInSlice.preCheckInStatus);

    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice)

    const { mobileCheckInConfigs } = useSelector((state) => state.deviceConfigSlice?.webAppWidgetsInfo);
    const checkinStartTime = `${formatTime(mobileCheckInConfigs.checkInStartTime, false)}:00`;

    const [checkinTimeLeft, setCheckinTimeLeft] = useState("");
    const diffRef = useRef(0);

    const calculateCheckinTimeLeft = useCallback(() => {
        const serverDateTime = new Date(serverTimeDataObj.date);

        const checkinDateTime = new Date(preCheckInData.checkinDate + "T" + checkinStartTime);

        diffRef.current = checkinDateTime - serverDateTime;
        setCheckinTimeLeft(formatTimeFormat(diffRef.current));
    }, [serverTimeDataObj, preCheckInData.checkinDate, checkinStartTime]);

    useEffect(() => {
        calculateCheckinTimeLeft();

        const interval = setInterval(() => {
            diffRef.current = Math.max(0, diffRef.current - 1000);
            setCheckinTimeLeft(formatTimeFormat(diffRef.current));
        }, 1000);

        return () => clearInterval(interval);
    }, [calculateCheckinTimeLeft]);

    return preCheckInCompleted ?
        <SliderPressable backgroundText={preCheckInWidgetState == PRE_CHECKIN ? t(`guest_details.button_desciption_pre_checked_in_checkin_timeleft`).replace("#CHECKINTIMELEFT", checkinTimeLeft) : null}  disabled={preCheckInWidgetState == PRE_CHECKIN} text={preCheckInWidgetState == EARLY_CHECKIN ? t('guest_details.request_early_checkin') : t('guest_details.proceed_checkin')} handleOnSuccess={handleOnSuccess} />
        :
        <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleOnSuccess} >
            <Text style={getStyles(['primaryBtnTxt'])}>{t('guest_details.proceed_pre_checkin')}</Text>
        </CustomPressable>
}